import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { IconButton, InputAdornment, TextField, Tooltip, Button } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import RefreshIcon from "@material-ui/icons/Refresh";
import { i18n } from "../../translate/i18n";
import TicketsUserSelect from "../TicketsUserSelect";
import TicketsQueueSelect from "../TicketsQueueSelect";

// feat_395 — barra de filtros del Tablero CRM. Presentación pura: el estado,
// la persistencia y la serialización (filterKey) viven en index.js.

const useStyles = makeStyles(theme => ({
  bar: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(1, 0),
  },
  search: { width: theme.spacing(28) },
  date: { width: theme.spacing(26) },
}));

const BoardFilters = ({
  search,
  onSearch,
  users,
  userSelection,
  onUserSelection,
  myUserId,
  dateFrom,
  dateTo,
  onDateFrom,
  onDateTo,
  onClear,
  showClear,
  onRefresh,
  // feat_396 — filtro de colas (TicketsQueueSelect, el mismo de la bandeja)
  userQueues = [],
  selectedQueueIds = [],
  onQueueChange,
  showAllTickets,
  showOrphans,
  canSeeOrphans,
  isAdmin,
  onToggleShowAll,
  onToggleShowOrphans,
}) => {
  const classes = useStyles();

  // userSelection null = "Todos" (sin filtro). Para el selector se expande a
  // todos los usuarios + "Sin asignar" (así lo dibuja tildado).
  const allIds = users.map(u => u.id);
  const selectedIds = userSelection ? userSelection.ids : allIds;
  const unassigned = userSelection ? userSelection.unassigned : true;
  const normalize = (ids, un) =>
    un && allIds.every(id => ids.includes(id)) ? null : { ids, unassigned: un };

  return (
    <div className={classes.bar}>
      <TextField
        className={classes.search}
        size="small"
        variant="outlined"
        placeholder={i18n.t("crmBoard.searchPlaceholder")}
        value={search}
        onChange={e => onSearch(e.target.value)}
        inputProps={{ "aria-label": i18n.t("crmBoard.searchPlaceholder"), maxLength: 100 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
      />
      {(isAdmin || canSeeOrphans || userQueues.length > 0) && (
        <TicketsQueueSelect
          userQueues={userQueues}
          selectedQueueIds={selectedQueueIds}
          onChange={onQueueChange}
          showAllTickets={showAllTickets}
          showOrphans={showOrphans}
          canSeeUnassigned={canSeeOrphans}
          isAdmin={isAdmin}
          onToggleShowAll={onToggleShowAll}
          onToggleShowOrphans={onToggleShowOrphans}
        />
      )}
      {users.length > 0 && (
        <TicketsUserSelect
          users={users}
          selectedUserIds={selectedIds}
          includeUnassigned={unassigned}
          onChangeUsers={ids => onUserSelection(normalize(ids, unassigned))}
          onChangeUnassigned={un => onUserSelection(normalize(selectedIds, un))}
          onToggleAllUsers={() =>
            onUserSelection(userSelection === null ? { ids: myUserId ? [myUserId] : [], unassigned: !myUserId } : null)
          }
        />
      )}
      <TextField
        className={classes.date}
        size="small"
        variant="outlined"
        type="date"
        label={i18n.t("crmBoard.dateFrom")}
        value={dateFrom}
        onChange={e => onDateFrom(e.target.value)}
        InputLabelProps={{ shrink: true }}
      />
      <TextField
        className={classes.date}
        size="small"
        variant="outlined"
        type="date"
        label={i18n.t("crmBoard.dateTo")}
        value={dateTo}
        onChange={e => onDateTo(e.target.value)}
        InputLabelProps={{ shrink: true }}
      />
      {showClear && (
        <Button size="small" onClick={onClear}>
          {i18n.t("crmBoard.clearFilters")}
        </Button>
      )}
      <Tooltip title={i18n.t("crmBoard.refresh")} arrow>
        <IconButton size="small" onClick={onRefresh} aria-label={i18n.t("crmBoard.refresh")}>
          <RefreshIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default BoardFilters;
